import axiosInstance from "auth/FetchInterceptor";
import { GET_ALL_PERMISSION } from "constants/ApiConstant";
const PermissionService = {};

PermissionService.getAllPermission = function (data) {
  return axiosInstance.post(GET_ALL_PERMISSION, data);
};

export default PermissionService;
